<template>
    <group-backend-layout page-title="Admins">
        <template #page_controls>
            <GroupInviteAnAdminModal />
        </template>

        <div class="">
            <easy-data-table
                v-if="groupAdmins.length"
                class="table"
                :headers="headers"
                :items="groupAdmins"
                :hide-footer="groupAdmins.length < 10"
                :rows-per-page="10"
                :rows-items="[10, 25, 50]"
                buttons-pagination
            >
                <template #item-full_name="admin">
                    <Link
                        v-if="
                            $page.props.auth.user
                                .group_admin_permission_level !== 'read-only' ||
                            $page.props.auth.user.id === admin.id
                        "
                        class="group hover:cursor-pointer hover:text-blue-500"
                        :href="
                            route('group.admin.show', {
                                user: admin.id,
                            })
                        "
                    >
                        <div class="flex items-center gap-2 whitespace-nowrap">
                            <UserAvatarRound :user="admin" size="28" />
                            <span class="group-hover:underline">
                                {{ admin.full_name }}
                            </span>
                        </div>
                    </Link>
                    <span v-else>
                        <div class="flex items-center gap-2 whitespace-nowrap">
                            <UserAvatarRound :user="admin" size="28" />
                            <span class="group-hover:underline">
                                {{ admin.full_name }}
                            </span>
                        </div>
                    </span>
                </template>
                <template #item-role="admin">
                    <GroupAdminPermissionSelectAndChange :admin="admin" />
                </template>
                <template #item-classrooms_managed_count="admin"
                    ><span class="text-gray-750"
                        >{{ admin.classrooms_managed_count }} class{{ admin.classrooms_managed_count != 1 ? 'es' : ''}}</span
                    ></template
                >
                <template #item-last_seen="admin"
                    ><span class="text-gray-750">
                        <span v-if="admin.last_seen">
                            {{
                                dayjs(admin.last_seen)
                                    .utc(true)
                                    .tz($page.props.auth.user.timezone)
                                    .format($page.props.date_formats.short_nice)
                            }}
                        </span>
                        <span v-else>--</span>
                    </span></template
                >
                <template #item-actions="admin">
                    <dropdown open-from="right" :px-width="260">
                        <template #button>
                            <more-dots-button />
                        </template>
                        <template #content>
                            <ul class="rounded border" @click="closeDropdown">
                                <li class="">
                                    <Link
                                        class="link block p-4"
                                        :href="
                                            route('user.send-password-reset', {
                                                user_id: admin.id,
                                            })
                                        "
                                    >
                                        Send password reset
                                    </Link>
                                </li>
                                <li class="">
                                    <group-delete-admin-button
                                        :admin="admin"
                                    ></group-delete-admin-button>
                                </li>
                            </ul>
                        </template>
                    </dropdown>
                </template>
            </easy-data-table>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import GroupAdminPermissionSelectAndChange from "@/Components/GroupAdminPermissionSelectAndChange";
import MoreDotsButton from "@/Components/MoreDotsButton";
import Dropdown from "@/Components/Dropdown";
import GroupInviteAnAdminModal from "@/Components/GroupInviteAnAdminModal";
import UserAvatarRound from "@/Components/UserAvatarRound";
import GroupDeleteAdminButton from "@/Components/GroupDeleteAdminButton";

export default {
    name: "GroupAdminsIndex",
    components: {
        GroupDeleteAdminButton,
        GroupInviteAnAdminModal,
        MoreDotsButton,
        GroupAdminPermissionSelectAndChange,
        GroupBackendLayout,
        Dropdown,
        UserAvatarRound,
    },
    props: {
        groupAdmins: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Admin",
                    value: "full_name",
                    sortable: true,
                },
                {
                    text: "Role",
                    value: "role",
                    sortable: true,
                    class: "!py-0",
                },
                {
                    text: "# of classes",
                    value: "classrooms_managed_count",
                    sortable: true,
                },
                {
                    text: "Last Seen",
                    value: "last_seen",
                    sortable: true,
                },
                {
                    text: "",
                    value: "actions",
                    width: 30,
                },
            ],
        };
    },
};
</script>
